export default () => {
  $('.js-video-modal-link').magnificPopup({
    type: 'iframe',
    closeMarkup: '<button title="%title%" type="button" class="mfp-close"><span class="sr-text">Close Pop-up</span></button>',
    iframe: {
      patterns: {
        youtube: {
          index: 'youtube.com/',
          id(url) {
            const m = url.match(/^.+youtube.com\/watch\?[^#]*v=([^&]+)/);
            if (m !== null) {
              if (typeof m[1] !== 'undefined') {
                return m[1];
              }
            }
            return null;
          },
          src: 'https://www.youtube.com/embed/%id%?autoplay=1&rel=0'
        },
        youtu_be: { // eslint-disable-line camelcase
          index: 'youtu.be/',
          id(url) {
            const m = url.match(/^.+youtu.be\/([^/?&#]+)/);
            if (m !== null) {
              if (typeof m[1] !== 'undefined') {
                return m[1];
              }
            }
            return null;
          },
          src: 'https://www.youtube.com/embed/%id%?autoplay=1&rel=0'
        }
      }
    }
  });
};
